import classnames from "classnames";
import moment from "moment";
import React, { SyntheticEvent } from "react";
import { Component } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { ObjectLiteral, parentDataRequiredToRegister } from "../../constants";
import { Props } from "../propTypes";
import { childFormComponent } from "./types";
import "semantic-ui-css/components/flag.min.css";
import "semantic-ui-css/components/dropdown.min.css";
import { ProgressIndicator } from "./ProgressIndicator";
import { withCookies } from "react-cookie";
import { ResetForm } from "./ResetForm";
// import "semantic-ui-css/semantic.min.css";

// Address Form Component
/**
 * This component is used to input and store a user's address information in MyElevation.
 *
 * We are using the Form and Button components from Semantic UI React Library.
 * For more information on these components can be found at https://react.semantic-ui.com/collections/form/
 * and https://react.semantic-ui.com/elements/button/
 *
 * The country and state values are being pulled from this.props.actions.main.main_(state/country)_list().
 * Check these actions and the api calls set up within them if you run into any problems.
 */

class Address extends Component<Props & childFormComponent> {
    state = {
        countryFocused: false,
        stateFocused: false,
    };
    // Component Did Mount Lifecycle Method
    /**
     * componentDidMount() runs immediately after the component mounts.
     */
    componentDidMount() {
        if (this.props.main.countries.length < 1) {
            this.props.actions.main.main_get_country_list();
        }

        if (this.props.main.states && this.props.main.states.length < 1) {
            this.props.actions.main.main_get_states_list();
        }

        //set US as the default
        // this.props.handleChange("countryName")(null, "US");
    }

    // Save and Continue Function
    /**
     * saveAndContinue() saves the values to the state and goes to the corresponding next step.
     * We are also checking if the country value matches the country abbreviation before storing it.
     */
    saveAndContinue = (e: any) => {
        e.preventDefault();
        const { values } = this.props;

        this.props.main.countries.forEach((country: ObjectLiteral) => {
            if (values.country === country.Abbrev) {
                this.props.handleChange("countryName")(null, country.Country);
            }
        });

        if (parentDataRequiredToRegister(moment(values.birthday))) {
            this.props.nextStep(12);
        } else {
            if (process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR === "1") {
                this.props.nextStep(6);
            } else {
                this.props.nextStep(11);
            }
        }
    };

    render() {
        const { values } = this.props;
        let buttonDisabled = true;

        if (
            this.props.main.countries.length > 0 &&
            ((values.country &&
                values.country !== "US" &&
                values.address &&
                values.city) ||
                (values.country &&
                    values.country === "US" &&
                    values.address &&
                    values.city &&
                    values.zip &&
                    values.state))
        ) {
            buttonDisabled = false;
        }

        return (
            <>
                <div className="col-xs-12 max-w-500 full-width center-content m-y-spacer-3xl">
                    <h2 className="text-dark text-left m-b-spacer-none text-center">
                        What&#39;s your Address?
                    </h2>
                    <Form className="p-y-spacer-xl">
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg",
                                {
                                    filled:
                                        values.country ||
                                        this.state.countryFocused,
                                }
                            )}
                        >
                            <label style={{ zIndex: 2 }}>Country</label>
                            <Dropdown
                                clearable
                                fluid
                                search
                                selection
                                selectOnBlur={false}
                                selectOnNavigation={false}
                                options={[
                                    {
                                        key: "dummy-option-fix-autoselection",
                                        text: "",
                                        value: "",
                                        className: "hide",
                                    },
                                    ...this.props.main.countries.map(
                                        (country) => {
                                            return {
                                                key: country.Abbrev,
                                                text: country.Country,
                                                value: country.Abbrev,
                                                flag: country.Abbrev.toLowerCase(),
                                            };
                                        }
                                    ),
                                ]}
                                onChange={(
                                    event: SyntheticEvent,
                                    data: ObjectLiteral
                                ) => {
                                    this.props.handleChange("country")(
                                        undefined,
                                        data.value
                                    );

                                    if (!data.value) {
                                        this.setState({
                                            countryFocused: false,
                                        });
                                    }
                                }}
                                onClick={() => {
                                    this.setState({ countryFocused: true });
                                }}
                                onBlur={() => {
                                    this.setState({ countryFocused: false });
                                }}
                                disabled={
                                    this.props.main.countries.length < 1 ||
                                    this.props.main.isLoading
                                }
                                onFocus={(e) => {
                                    (e.target as any).setAttribute(
                                        "autocomplete",
                                        "nope"
                                    );
                                }}
                                value={values.country}
                                className="p-x-spacer-md ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                name="country"
                            />
                            {/* <select
                            disabled={
                                this.props.main.countries.length < 1 ||
                                this.props.main.isLoading
                            }
                            defaultValue={values.country}
                            className="ec-dropdown p-x-spacer-md ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                            onChange={this.props.handleChange("country")}
                        >
                            {this.props.main.countries.map(
                                (country: ObjectLiteral, key: number) => {
                                    // if (country.Abbrev !== "US") {
                                    return (
                                        <option
                                            key={key}
                                            value={country.Abbrev}
                                        >
                                            {country.Country}
                                        </option>
                                    );
                                    // }
                                }
                            )}
                        </select> */}
                        </Form.Field>
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg ",
                                {
                                    filled: values.address,
                                }
                            )}
                        >
                            <label>Address</label>
                            <input
                                className="p-x-spacer-lg ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                onChange={this.props.handleChange("address")}
                                defaultValue={values.address}
                                maxLength={100}
                            />
                        </Form.Field>
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg ",
                                {
                                    filled: values.city,
                                }
                            )}
                        >
                            <label>City</label>
                            <input
                                className="p-x-spacer-lg no-border ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                onChange={this.props.handleChange("city")}
                                defaultValue={values.city}
                                maxLength={50}
                            />
                        </Form.Field>
                        {values.country === "US" ? (
                            <Form.Field
                                className={classnames(
                                    "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg",
                                    {
                                        filled:
                                            values.state ||
                                            this.state.stateFocused,
                                    }
                                )}
                            >
                                <label style={{ zIndex: 2 }}>State</label>
                                {/* <Form.Field
                                control="select"
                                onChange={this.props.handleChange("state")}
                                defaultValue={values.state}
                                className="p-x-spacer-lg ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                disabled={
                                    (this.props.main.states &&
                                        this.props.main.states.length < 1) ||
                                    this.props.main.isLoading
                                }
                                name="state"
                            >
                                <option value="">State</option>
                                {this.props.main.states &&
                                    this.props.main.states.map(
                                        (state: ObjectLiteral, key: number) => (
                                            <option
                                                key={key}
                                                value={state.Abbrev}
                                            >
                                                {state.State}
                                            </option>
                                        )
                                    )}
                            </Form.Field> */}

                                <Dropdown
                                    clearable
                                    fluid
                                    search
                                    selection
                                    selectOnBlur={false}
                                    selectOnNavigation={false}
                                    options={[
                                        {
                                            key: "dummy-option-fix-autoselection",
                                            text: "",
                                            value: "",
                                            className: "hide",
                                        },
                                        ...this.props.main.states?.map(
                                            (state: ObjectLiteral) => {
                                                return {
                                                    key: state.Abbrev,
                                                    text: state.State,
                                                    value: state.Abbrev,
                                                };
                                            }
                                        ),
                                    ]}
                                    onChange={(
                                        event: SyntheticEvent,
                                        data: ObjectLiteral
                                    ) => {
                                        this.props.handleChange("state")(
                                            undefined,
                                            data.value
                                        );

                                        if (!data.value) {
                                            this.setState({
                                                stateFocused: false,
                                            });
                                        }
                                    }}
                                    onClick={() => {
                                        this.setState({ stateFocused: true });
                                    }}
                                    onBlur={() => {
                                        this.setState({ stateFocused: false });
                                    }}
                                    disabled={
                                        (this.props.main.states &&
                                            this.props.main.states.length <
                                                1) ||
                                        this.props.main.isLoading
                                    }
                                    onFocus={(e) => {
                                        (e.target as any).setAttribute(
                                            "autocomplete",
                                            "nope"
                                        );
                                    }}
                                    value={values.state}
                                    className="p-x-spacer-md ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                    name="state"
                                />
                            </Form.Field>
                        ) : null}

                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg ",
                                {
                                    filled: values.zip,
                                }
                            )}
                        >
                            <label>Zip Code</label>
                            <input
                                className="p-x-spacer-lg no-border ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                type="text"
                                onChange={this.props.handleChange("zip")}
                                defaultValue={values.zip}
                                min={0}
                            />
                        </Form.Field>

                        {this.props.isLoading ? (
                            <div className="form-loading rel-pos  m-t-spacer-md  way-forward full-width uptop">
                                <div className="la-ball-clip-rotate la-color la-md loading-spin abs-pos absolute-center">
                                    <div />
                                </div>
                            </div>
                        ) : (
                            <Button
                                className="full-width no-border text-white  p-y-spacer-md uppercase let-sp-reg hover-grow ec-border-radius"
                                onClick={this.saveAndContinue}
                                disabled={buttonDisabled}
                                id={`${this.props.tagPrefixId}-address-next`}
                            >
                                Next
                            </Button>
                        )}
                    </Form>

                    <div className="m-b-spacer-lg">
                        <ProgressIndicator currentStep={values.step} />
                    </div>
                </div>
                <ResetForm
                    idPrefix={`${this.props.tagPrefixId}-address`}
                    cancelUrl={this.props.cancelUrl || ""}
                />
            </>
        );
    }
}

export default withCookies(Address);
